module.exports = " <div class=vc-card-tools> <slot></slot> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/card/cardTools.vue
 ** module id = 432
 ** module chunks = 1
 **/